/** @format */
import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import {
  Grid,
  Button,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputLabel,
} from '@mui/material';
import { SimpleDialog, InputV2, Icons } from 'components';
import KeyGen from './KeyGen';
import { RadioButtonIcon, RadioButtonIconFill } from 'components/CheckBox/RadioButtonIcon';

const PublicKey = (props) => {
  // -- STATES --//
  const [isKeyGenOpen, setIsKeyGenOpen] = useState(false);

  // -- HOOKS --//
  const classes = useStyles();
  const { className, data, setData, ...rest } = props;

  // -- OTHER FUNCTIONS --//
  const handleCloseKeyGenModal = (newPublicKey, newKeyFormat) => {
    if (newPublicKey && newKeyFormat) {
      setData({ publicKey: newPublicKey, keyFormat: newKeyFormat });
    }
    setIsKeyGenOpen(false);
  };
  return (
    <div className={classes.root}>
      <Grid container spacing={3} className={classes.container}>
        {/* TODO: Clarify situations to show bellow card + Details and Styles */}
        <Grid
          item
          xs={12}
          container
          justifyContent="space-between"
          alignItems="center"
          className={classes.keyGenLine}
        >
          <Grid item>
            <Typography className={classes.keyGenLineTitle}>کلید عمومی و خصوصی ندارید؟</Typography>
            <Typography className={classes.keyGenLineSubTitle}>
              ابزار ایجاد کلیدهای عمومی و خصوصی
            </Typography>
          </Grid>

          <Button color="primary" variant="contained" onClick={() => setIsKeyGenOpen(true)}>
            ایجاد کلید
          </Button>
        </Grid>
        <Grid item xs={12} style={{ marginInlineStart: 10 }}>
          <InputLabel shrink htmlFor="bootstrap-input" className={classes.label}>
            <span className={classes.asterisk}>* &nbsp;</span>
            نوع کلید عمومی
          </InputLabel>
          <RadioGroup
            row
            required
            onChange={(e) => setData({ keyFormat: e?.target?.value, publicKey: data?.publicKey })}
            value={data?.keyFormat}
            defaultValue="xml"
          >
            <FormControlLabel value="xml" control={<Radio color="primary" icon={<RadioButtonIcon />} checkedIcon={<RadioButtonIconFill />} />} label="XML" />
            <FormControlLabel value="pem" control={<Radio color="primary" icon={<RadioButtonIcon />} checkedIcon={<RadioButtonIconFill />} />} label="PEM" />
          </RadioGroup>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12} style={{ marginInlineStart: 10 }}>
          <InputV2
            errors={{}}
            forceValue={data?.publicKey}
            name="publicKey"
            label="کلید عمومی"
            register={{}}
            onChangeValue={(e) =>
              setData({ publicKey: e?.target?.value, keyFormat: data?.keyFormat })
            }
            fullWidth
            multiline
            dir="ltr"
            mainStyle={{ margin: 0, width: '100%' }}
            inputProps={{ style: { marginBottom: 0, minHeight: 200 } }}
          //   TODO: add validation rules
          />
        </Grid>
        <SimpleDialog
          fullWidth
          maxWidth="md"
          open={isKeyGenOpen}
          onClose={() => handleCloseKeyGenModal()}
          title="ایجاد کلید عمومی و خصوصی"
          icon={<Icons icon="Key" color="#ffffff" size="20" />}
        >
          <KeyGen onClose={handleCloseKeyGenModal} />
        </SimpleDialog>
      </Grid>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: theme.spacing(2),
  },
  container: {
    maxWidth: '450px',
  },
  formControl: {
    width: '100%',
  },
  button: {
    minWidth: '135px',
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  buttonWrapper: {
    // textAlign: "right",
  },
  textArea: {
    width: '100%',
    textAlign: 'right',
    direction: 'rtl',
    padding: theme.spacing(2),
  },
  label: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#546e7a',
    marginBottom: 10,
    '&.MuiInputLabel': {
      '&-shrink': {
        transform: 'translate(0, 1.5px) scale(1)',
      },
    },
  },
  asterisk: {
    color: '#ef5350',
  },
  keyGenLine: {
    background: '#eceff1',
    border: 'solid 1px #cfd8dc',
    padding: theme.spacing(1),
    boxSizing: 'border-box',
    marginInlineStart: theme.spacing(2.5),
    marginInlineEnd: theme.spacing(1.5),
    borderRadius: 4,
  },
  keyGenLineTitle: {
    fontSize: 14,
  },
  keyGenLineSubTitle: {
    fontSize: 12,
    color: '#5e7986',
    fontWeight: '300',
    margin: 0,
  },
}));

export default PublicKey;
